'use strict';

exports.__esModule = true;
var ON_MOUSE_ENTER = exports.ON_MOUSE_ENTER = 'WEVE_GOT_YOU_COVERED:MOUSE_ENTER';
var ON_MOUSE_LEAVE = exports.ON_MOUSE_LEAVE = 'WEVE_GOT_YOU_COVERED:MOUSE_LEAVE';
var UPDATE_ACTIVE_BOX = exports.UPDATE_ACTIVE_BOX = 'WEVE_GOT_YOU_COVERED:UPDATE_ACTIVE_BOX';

var WeveGotYouCoveredActions = {
	onMouseLeave: function onMouseLeave() {
		return { type: ON_MOUSE_LEAVE };
	},
	onMouseEnter: function onMouseEnter() {
		return { type: ON_MOUSE_ENTER };
	},
	updateActiveBox: function updateActiveBox(activeBox) {
		return { type: UPDATE_ACTIVE_BOX, activeBox: activeBox };
	}
};

exports.default = WeveGotYouCoveredActions;


// WEBPACK FOOTER //
// ./components/home-page/lib/actions/weve-got-you-covered.js